'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('immutable'),
    Record = _require.Record;

var DEFAULTS = {
    // The type of table blocks
    typeTable: 'table',
    // The type of row blocks
    typeRow: 'table_row',
    // The type of cell blocks
    typeCell: 'table_cell',
    // The type of block inserted when exiting
    exitBlockType: 'paragraph'
};

/**
 * The plugin options
 */

var Options = function (_ref) {
    _inherits(Options, _ref);

    function Options() {
        _classCallCheck(this, Options);

        return _possibleConstructorReturn(this, (Options.__proto__ || Object.getPrototypeOf(Options)).apply(this, arguments));
    }

    return Options;
}(new Record(DEFAULTS));

module.exports = Options;


//////////////////
// WEBPACK FOOTER
// ../node_modules/slate-edit-table/dist/options.js
// module id = 1135
// module chunks = 0